import { IAdvantages } from '../../../repositories/developer-card/entities/developer_special_promo/Advantages';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoAdvantages(state: IApplicationState): IAdvantages | undefined {
  return getTemplateSpecialPromo(state)?.advantages ?? undefined;
}
